import styled from "@emotion/styled";
import { Table, TreeSelect } from "antd";

// Styled table component for Market Overview
export const MarketOverviewTable = styled(Table)`
  .ant-table {
    background: #ffffff;
  }

  .ant-table-thead > tr > th {
    background-color: #fafafa;
    color: #27272a;
    font-weight: 600;
    font-size: 14px;
  }

  .ant-table-tbody > tr > td {
    font-size: 14px;
  }

  .ant-table-tbody > tr:hover > td {
    background-color: #f4f4f5;
  }
`;

// Styled tree select for filtering
export const FilterTreeSelector = styled(TreeSelect)`
  width: 100%;
  
  .ant-select-selector {
    border-radius: 6px;
  }
`;

